import React, { useCallback, useEffect, useState } from 'react';
import { Translation } from 'react-i18next';
import { useConfig } from '../../contexts/configContext';
import { LoadScript } from '../../types/LoadScript';
import LoadableComponent from '../loadable-component/LoadableComponent';
import ContentLoadErrorPlaceholder from '../loadable-component/templates/content/ContentLoadErrorPlaceholder';
import ContentLoadPlaceholder from '../loadable-component/templates/content/ContentLoadPlaceholder';

type Props = {
    selectedLanguage: string,
    documentType: string,
    documentUri: string,
    onLoadCallback: () => void,
    onErrorCallback: () => void
}

const MyMedia = (props: Props) => {

    const { myMedia } = useConfig()

    const message = <Translation>{t => t("Unfortunately we could not load this component.")}</Translation>;

    const [scriptsToBeLoaded, setScriptsToBeLoaded] = useState<LoadScript[]>([])

    const [language, setLanguage] = useState<string>()

    const getScripts = useCallback(() => {
        if (myMedia.webComponentUrl) {
            setScriptsToBeLoaded([
                { url: `${myMedia.webComponentUrl}/build/my-media.esm.js`, type: "module", nomodule: false },
                { url: `${myMedia.webComponentUrl}/build/my-media.js`, type: "application/javascript", nomodule: true },
            ])
        }
    }, [myMedia.webComponentUrl])

    useEffect(() => {
        getScripts()
        setLanguage(props.selectedLanguage)
    }, [getScripts])

    return (
        <LoadableComponent
            loadPlaceholder={ContentLoadPlaceholder}
            errorPlaceholder={ContentLoadErrorPlaceholder}
            scriptsToBeLoaded={scriptsToBeLoaded}
            message={message}
            {...props}>
            <my-media-main
                global-pdf-url={props.documentUri}
                document-type={props.documentType}
                language={language}
                base-url={myMedia.baseUrl}
                api-url={myMedia.companyRelationsApiUrl}
                token-is-provided={true} />
        </LoadableComponent>
    )
}

export default MyMedia;